import createStartButtonLogger from "./start-button";
import createPreviewDialogLogger from "./preview-dialog";
import createThirdPartyAssessmentLogger from "./third-party";
export default function createStartAssessmentLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `start:${input.type}` });
    return {
        detected(details) {
            return log({
                type: "detected",
                details,
            });
        },
        injectionSkipped(reason) {
            return log({
                type: "injection-skipped",
                details: { reason },
            });
        },
        notifiedLms(details) {
            return log({
                type: "notified-lms",
                details,
            });
        },
        returnedToStartPage(url) {
            return log({
                type: "returned-to-start-page",
                details: { url },
            });
        },
        startButton: createStartButtonLogger(log),
        previewDialog: createPreviewDialogLogger(log),
        thirdParty: createThirdPartyAssessmentLogger(log),
    };
}
